import { HttpClient } from "../HttpClient";

/**
 * * Get Contents (POST version using request body)
 */
export const GetContentListFromArray = async ({
  searchString,
  userId,
  claimStatus,
  sortColumn = "id",
  sortOrder = "desc",
  pageNumber = 1,
  rowsPerPage,
  assetLabels,
  claimedBy = "unclaimed",
  triggeredBy,
  claimant
}) => {
  try {
    const { data } = await HttpClient.post("api/contents/Array/List", {
      ...(userId && { userId }),
      pageNumber,
      rowsPerPage,
      assetLabels,
      ...(claimStatus !== undefined ? { claimStatus } : {}),
      ...(searchString && { searchString }),
      ...(sortColumn && { sortColumn }),
      ...(sortOrder && { sortOrder }),
      claimedBy,
      triggeredBy,
      claimant
    });
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
